import React  from 'react';
import NaviBar from './Block/NaviBar.js'

const Header = () => {
        return (
            <NaviBar />
        )
}

export default Header



// WEBPACK FOOTER //
// ./src/App/Header/Header.js